import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface CreateMappingButtonProps {
  onOpenModal: () => void;
}

export const CreateMappingButton = ({ onOpenModal }: CreateMappingButtonProps) => {
  const { t } = useTranslation('mappingsModule');

  return (
    <Button variant="primary" size="lg" onClick={onOpenModal} data-testid="create-mapping-button">
      {t('create_button')}
    </Button>
  );
};
